import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { legacy2, filler } from '../../assets/icons/icon';
import './paymentGateway.scss';
import razorpay from './images/razorpay_icon.svg';
import cashfree from './images/cashfree.svg';
import enroll_logo from './images/enroll_logo.svg';
import CustomModal from '../TermsandCondition/t&Cpopup';
import EditStudent from './EditStudent';

const PaymentGatewaySelection = ({
  currentCourse,
  formData,
  courseFee,
  isLoad,
  handlePaymentSubmit,
  courseFormattedTitle,
  courseImage,
  courseTimings,
  selectedDuration,
  isEditStudentOpen,
  setEditStudentOpen,
  setFormData,       
            empty,                       
            setEmpty,
            handleSubmit,
            dateDurationChange,
  onBack
}) => {
  const [selectedGateway, setSelectedGateway] = useState('cashfree');
  const [isPaymentCheckboxChecked, setIsPaymentCheckboxChecked] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [openterms, setOpenterms] = useState(false);
  const navigate = useNavigate();

  const [editOpen, setEditOpen] = useState(false)
  const [updateAddress, setUpdateAddress] = useState({
  address1: formData?.address1,
  address2: formData?.address2,
  state: formData?.state,
  country: formData?.country,
  pincode: formData?.pincode,
});
const [defaultAddress, setDefaultAddress] = useState(true);
  

  
    const handleEditOpen = () => {
  
      setEditOpen(true);
  
    }
  
    const handleEditClose = () => {
  
      setEditOpen(false);
  
      setEditStudentOpen(false);
  
    };

  const handleOpenTerms = () => setOpenterms(true);
  const handleCloseTerms = () => setOpenterms(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Calculate fees (fallback)
  const baseCourseFee = Number(courseFee) || 0;

  const handleClosePayment = () => {
    if (typeof onBack === 'function') {
      onBack();
      return;
    }
    navigate(-1);
  };

  const handlePaymentGatewaySelect = (gateway) => {
    setSelectedGateway(gateway);
  };

  const handleConfirmPayment = async () => {
    if (!isPaymentCheckboxChecked) {
      return;
    }
    setIsProcessing(true);
    try {
      await handlePaymentSubmit(selectedGateway, baseCourseFee);
    } catch (error) {
      console.error('Payment processing error:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const fmt = (n) => Number(n).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const fmtCurrency = (n) => `INR ${fmt(n)}`;

  const getCourseFormatDisplay = () => {
    if (formData?.mode === 'ONLINE') return 'Online';
    if (formData?.mode === 'OFFLINE') {
      if (formData?.residental === 'RESIDENTIAL') return 'On Campus - Residential';
      if (formData?.residental === 'NONRESIDENTIAL') return 'On Campus - Non Residential';
      return 'On Campus';
    }
    return null;
  };

  const getCourseDateDisplay = () => {
    if (formData?.sdate && formData.sdate !== 'No date Selected') return formData.sdate;
    if (formData?.startDate) return formData.startDate;
    return null;
  };

  const getDurationDisplay = () => {
    if (selectedDuration) return selectedDuration;
    return currentCourse?.duration || null;
  };

  return (
    <div className="pgw-page">
      {/* ── Header ── */}
      <div className="pgw-header">
        <div className="pgw-header__logo-container">
          <Link to="/" className="pgw-header__logo">
            <img src={enroll_logo} alt="The Yoga Institute" />
          </Link>
        </div>
        <button type="button" className="pgw-header__close" onClick={handleClosePayment}>
          <span className="pgw-header__close-icon">✕</span> Close
        </button>
      </div>

      {/* ── Course Hero (2-Column) ── */}
      <div className="pgw-hero">
        <div className="pgw-hero__left">
          <div className="pgw-hero__img-wrap">
            <img 
              src={currentCourse?.image} 
              alt={currentCourse?.title} 
              className="pgw-hero__img" 
            />
          </div>
        </div>
        
        <div className="pgw-hero__right">
          <p className="pgw-hero__label">YOUR SELECTED COURSE DETAILS</p>
          <h2 className="pgw-hero__title">{currentCourse?.title}</h2>
          {courseFormattedTitle && (
            <p className="pgw-hero__desc">{courseFormattedTitle}</p>
          )}
          
          <div className="pgw-hero__meta-table">
            {getDurationDisplay() && (
  <div className="pgw-meta-row">
    <span className="pgw-meta-row__label">Course Duration:</span>
    <span className="pgw-meta-row__value">{getDurationDisplay()}</span>
  </div>
)}
            <div className="pgw-meta-row">
              <span className="pgw-meta-row__label">Course Format:</span>
              <span className="pgw-meta-row__value">
                {getCourseFormatDisplay() || 'N/A'} - ₹{fmt(baseCourseFee)}
              </span>
            </div>
            <div className="pgw-meta-row">
              <span className="pgw-meta-row__label">Course Date:</span>
              <span className="pgw-meta-row__value">
                {(() => {
                  const dateVal = getCourseDateDisplay() || courseTimings;
                  if (!dateVal) return 'N/A';
                  return dateVal.length > (isMobile ? 15 : 40)
                    ? `${dateVal.substring(0, isMobile ? 15 : 40)}...`
                    : dateVal;
                })()}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ── Two-column body ── */}
      <div className="pgw-body">
        {/* Left – Student Details */}
      <div className="pgw-student">
        <div className="pgw-student__watermark">{filler}</div>
        
        <div className="pgw-student__header">
          <span className="pgw-student__title">Student details</span>
          {onBack && (
            <button className="pgw-student__edit" onClick={handleEditOpen} title="Edit details">
            <img src='/images/edit_icon.svg' style={{ cursor: 'pointer' }} alt='' loading='lazy' />
            </button>
          )}
        </div>
        
        <div className="pgw-student__rows">
          {[
            { label: 'Name', value: formData?.name },
            { label: 'Email Address', value: formData?.email },
            { label: 'Mobile Number', value: formData?.phone },
            { label: 'Address', value: [formData?.address1, formData?.address2].filter(Boolean).join(', ') },
            { label: 'City', value: formData?.city },
            { label: 'Country', value: formData?.country },
            { label: 'Gender', value: formData?.gender },
            { label: 'Pincode', value: formData?.pincode },
          ].filter(r => r.value).map(({ label, value }) => (
            <div className="pgw-student__row" key={label}>
              <span className="pgw-student__row-label">{label}</span>
              <span className="pgw-student__row-value">
                {String(value).length > (isMobile ? 20 : 33) 
                  ? `${String(value).substring(0, isMobile ? 20 : 33)}...` 
                  : value}
              </span>
            </div>
          ))}

          {(editOpen || isEditStudentOpen) && (
      
                          <EditStudent isShippingModalOpen={handleEditOpen} setIsShipppingModalOpen={handleEditClose} formData={formData} setFormData={setFormData} setEmpty={setEmpty} empty={empty} currentCourse={currentCourse} dateDurationChange={dateDurationChange} handleSubmit={() => {/* save only, no resubmit */}} setUpdateAddress={setUpdateAddress} setDefaultAddress={setDefaultAddress} />
      
                        )}
        </div>
      </div>

      

        {/* Right – Gateway + Summary + CTA */}
        <div className="pgw-right">
          {/* Gateway Selection */}
          <div className="pgw-gateways-card">
            <h3 className="pgw-right-title">Select Payment Gateway</h3>
            <div className="pgw-gateways-grid">
              {/* Razorpay */}
              <div
                className={`pgw-method-card ${selectedGateway === 'razorpay' ? 'pgw-method-card--active' : ''}`}
                onClick={() => handlePaymentGatewaySelect('razorpay')}
              >
                <div className="pgw-method-card__logo-wrap">
                   <div className="pgw-logo-box pgw-logo-box--razorpay">
                    <img src={razorpay} alt='razorpay' loading='lazy' />
                   </div>
                </div>
                <div className="pgw-method-card__info">
                   <span className="pgw-method-card__name">Razorpay</span>
                   <span className="pgw-method-card__sub">card, upi, netbanking</span>
                </div>
                <div className="pgw-method-card__radio">
                  <div className={`pgw-radio-dot ${selectedGateway === 'razorpay' ? 'pgw-radio-dot--active' : ''}`} />
                </div>
              </div>

              {/* Cashfree */}
              <div
                className={`pgw-method-card ${selectedGateway === 'cashfree' ? 'pgw-method-card--active' : ''}`}
                onClick={() => handlePaymentGatewaySelect('cashfree')}
              >
                <div className="pgw-method-card__logo-wrap">
                   <div className="pgw-logo-box pgw-logo-box--cashfree">
                     <img src={cashfree} alt='cashfree' loading='lazy' />
                   </div>
                </div>
                <div className="pgw-method-card__info">
                   <span className="pgw-method-card__name">Cashfree</span>
                   <span className="pgw-method-card__sub">card, upi, netbanking</span>
                </div>
                <div className="pgw-method-card__radio">
                  <div className={`pgw-radio-dot ${selectedGateway === 'cashfree' ? 'pgw-radio-dot--active' : ''}`} />
                </div>
              </div>
            </div>
          </div>

          {/* Payment Summary Box */}
          <div className="pgw-summary-card">
            <h3 className="pgw-summary-title">Payment Summary</h3>
            <div className="pgw-summary-box">
              <div className="pgw-summary-rows">
                <div className="pgw-summary-row">
                  <span className="pgw-summary-row__label">Course Fee</span>
                  <span className="pgw-summary-row__value">₹{fmt(baseCourseFee)}</span>
                </div>
                <div className="pgw-summary-divider"></div>
                <div className="pgw-summary-row pgw-summary-row--total">
                  <span className="pgw-summary-row__label--total">Total Payable</span>
                  <span className="pgw-summary-row__value--total">₹{fmt(baseCourseFee)}</span>
                </div>
                <p className="pgw-summary-note">
                  Payment gateway charges are applicable based on the selected payment method
                </p>
              </div>
            </div>

            <div className="pgw-footer-flex">
              <div className="pgw-terms-box">
                <input
                  type="checkbox"
                  id="pgwTermsAccept"
                  checked={isPaymentCheckboxChecked}
                  onChange={(e) => setIsPaymentCheckboxChecked(e.target.checked)}
                  className="pgw-checkbox"
                />
                <label htmlFor="pgwTermsAccept" className="pgw-terms-label">
                  I agree and accept the{' '}
                  <span 
                    onClick={handleOpenTerms} 
                    style={{ color: "#CA4625", cursor: "pointer", textDecoration: "underline", marginLeft: "4px" }}
                  >
                    Terms and Conditions
                  </span>
                </label>
              </div>

              <button
                onClick={handleConfirmPayment}
                disabled={!isPaymentCheckboxChecked || isProcessing || isLoad}
                className={`pgw-pay-btn ${(!isPaymentCheckboxChecked || isProcessing || isLoad) ? 'pgw-pay-btn--disabled' : ''}`}
              >
                {isProcessing || isLoad ? (
                   <div className="pgw-spinner"></div>
                ) : (
                  `Pay & Confirm Enrollment - ${fmtCurrency(baseCourseFee)}`
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      {openterms && (
        <CustomModal 
          isShippingModalOpen={openterms} 
          setIsShipppingModalOpen={setOpenterms} 
        />
      )}
    </div>
  );
};

export default PaymentGatewaySelection;